export const departmentFromDto = (dto) => ({
  id: dto.id,
  name: dto.name,
  code: dto.code,
});
